const EXPERIENCES_ENABLED = process.env.EXPERIENCES_ENABLED;
const EXPERIENCES = [
  {
    name: 'Veloren',
    title: 'Learn more about Veloren!',
    url: '/ex/veloren/index.html',
    icon: '/ex/veloren/logo.png'
  },
  {
    name: 'PaddlePunks',
    title: 'Learn more about PaddlePunks!',
    url: '/ex/paddlepunks/index.html',
    icon: '/ex/paddlepunks/logo.png'
  },
];

const EX_TRIGGER_SELECTOR = '.experience__triggers';

import { html, render } from 'lit-html';

import { showEmbed, clearContents } from './sidebar.js';



function init() {
  let exs = EXPERIENCES;

  const triggers = document.querySelector(EX_TRIGGER_SELECTOR);
  if (!triggers) {
    return console.log('Failed to initialize Experiences');
  }

  // Customize which experiences are enabled
  if (EXPERIENCES_ENABLED) {
    // Can be a string (comma-separated list of numbers)
    exs = EXPERIENCES_ENABLED.split(',').map(i => EXPERIENCES[i-1]);
  }

  // Render the experience triggers
  render(exs.map( (p, idx) => tExperienceTriggerBtn(p, idx)), triggers);

  // Initialize click handlers
  triggers.addEventListener('click', e => {
    let el = e.target;
    if (el.tagName !== 'BUTTON') return;

    // Show experience assigned to this button
    let src = el.dataset.ex;
    if (!src) {
      clearContents();
      return;
    }

    //
    document.documentElement.dataset.exnow=el.dataset.idx;

    // Toggle content on/off
    showEmbed(src);
  });
}

const tExperienceTriggerBtn = (p, idx) => html`
<button data-ex="${p.url}" data-idx="${idx}" class="experience__triggers__b">
<img src="${p.icon}"
  alt="${p.name}"
  title="${p.title}">
<span>${p.name}</span>
</button>
`;


init();

